// for revert

import React, { useContext, useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Container from './common/Container';
import { MeContext } from './common/contexts/me.context';
import { ToastProvider } from './common/contexts/toast.context';
import Toasts from './common/toasts/Toasts';
import AccountSettings from './pages/account-settings/AccountSettings';
import Accounts from './pages/accounts/Accounts';
import SubscriptionCheckout from './pages/billing/subscription-checkout/SubscriptionCheckout';
import Blog from './pages/blog/Blog';
import Contact from './pages/contact/Contact';
import Dashboard from './pages/dashboard/Dashboard';
import Dealers from './pages/dealers/Dealers';
import LoggedOut from './pages/logged-out/LoggedOut';
import Manufacturers from './pages/manufacturers/Manufacturers';
import Products from './pages/products/Products';
import Profile from './pages/profile/Profile';
import Users from './pages/users/Users';
import { RM } from '@request-metrics/browser-agent';
import AdRequest from './pages/display-ads/AdRequest';
import NotFound from './pages/NotFound';
import { Auth, Hub } from 'aws-amplify';
import { AuthState } from '@aws-amplify/ui-components';
import './index.css';
import Loading from './common/Loading';
import DisplayAdsList from './pages/display-ads/DisplayAdsList';

RM.install({ token: 'e3eu9ru:t7ce8fx' });

const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { me } = useContext(MeContext);
	return me?.role === 'superAdmin' ? <>{children}</> : <NotFound />;
};

const queryClient = new QueryClient();

function App() {
	const [authState, setAuthState] = useState<string | null | undefined>(null);
	const [user, setUser] = useState<object | undefined>();

	useEffect(() => {
		if (!authState) {
			Auth.currentAuthenticatedUser()
				.then((authData) => {
					setAuthState(AuthState.SignedIn);
					setUser(authData);
				})
				.catch((e) => {
					console.log(e);
					setAuthState(undefined);
				});
		}
	}, [authState, user]);

	useEffect(() => {
		const unsubscribe = Hub.listen('auth', ({ payload: { event } }) => {
			if (event === 'signOut') {
				setAuthState(undefined);
				setUser(undefined);
			}
		});
		return unsubscribe;
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<ToastProvider>
				<Router>
					{authState === 'signedin' ? (
						<Container>
							<Routes>
								<Route path="/" element={<Dashboard />} />
								<Route
									path="/account-settings/*"
									element={<AccountSettings />}
								/>
								<Route path="/profile/*" element={<Profile />} />
								<Route path="/users/*" element={<Users />} />
								<Route path="/accounts/*" element={<Accounts />} />
								<Route path="/dealers/*" element={<Dealers />} />
								<Route path="/products/*" element={<Products />} />
								<Route path="/manufacturers/*" element={<Manufacturers />} />
								<Route path="/contact/*" element={<Contact />} />
								<Route
									path="/blog/*"
									element={<SuperAdminRoute><Blog /></SuperAdminRoute>}
								/>
								<Route path="/billing/*" element={<SubscriptionCheckout />} />
								<Route
									path="/ad-requests/*"
									element={
										<SuperAdminRoute>
											<AdRequest />
										</SuperAdminRoute>
									}
								/>
								<Route
									path="/display-ads-list"
									element={
										<SuperAdminRoute>
											<DisplayAdsList />
										</SuperAdminRoute>
									}
								/>
							</Routes>
						</Container>
					) : authState === null ? (
						<Loading />
					) : (
						<LoggedOut onAuth={setUser} />
					)}
				</Router>
				<Toasts />
			</ToastProvider>
		</QueryClientProvider>
	);
}

export default App;
